import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fam-soke-userpolicy',
  templateUrl: './soke-userpolicy.component.html',
  styleUrls: ['./soke-userpolicy.component.scss']
})
export class SokeUserpolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
